import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../../Components/Themed";
import type { PublicPlayerProps, TextTagProps } from '../../../types';
import { SocialComponentApi } from '../../api';
import { FlatList, Image } from 'react-native';
import SearchBox from '../../../Components/SearchBox';
import Pagination from '../../../Components/Pagination';

type TagSelectorProps = {
    type: 'player',
    width:number,
    visible:boolean,
    onFocusPosition?:(position:{ height:number, width:number, x:number, y:number }) => void
    working_tag:TextTagProps,
    onCancel: () => void,
    onSelectTag:(tag:TextTagProps) => void
}
const MIN_TAG_WIDTH = 140
const TagSelector = ({ width, type, visible, working_tag, onFocusPosition, onSelectTag, onCancel } : TagSelectorProps) => {
    const [ player_search, setPlayerSearch ] = useState('');
    const [ player_tag, setPlayerTag ] = useState<{
        loading:boolean,
        players:PublicPlayerProps[],
        player_local_offset:number,
        offset:number
    }>({
        loading: false, players:[], offset:0, player_local_offset:0
    });
    let visible_players = player_tag.players.slice(0, 8);
    const getTagWidth = (padding:number) => {
        //How many can fit in the screen
        let num_possible = Math.floor(width / MIN_TAG_WIDTH);
        // then simply divide the width with it!
        let width_per_tag = (width / num_possible) - (padding * 2 * num_possible)
        return width_per_tag
    }
    const tag_width = getTagWidth(4)

    useEffect(() => {
        if(!visible){ return }
        startUpSelector(type, working_tag)
    },[visible, working_tag]);

    const startUpSelector = async(type:'player', working_tag:TextTagProps) => {
        switch(type){
            case 'player':
                return searchPlayers(working_tag, 0);
            default: return //Not handled
        }
    }

    const searchPlayers = async(tag:TextTagProps, page:number) => {
        setPlayerTag({ ...player_tag, loading: true });
        const plys = await SocialComponentApi.searchPlayersByValue(tag.tag, page);
        setPlayerTag({
            ...player_tag,
            loading: false,
            players: plys,
            offset: page
        })
    }

    const handleSelectPlayer = (player:PublicPlayerProps) => {
        if(!working_tag){ return }
        onSelectTag({
            ...working_tag,
            tag: player.username,
            data: player,
            tag_type_id: player.player_id,
            valid: true
        })
    }

    const searchPlayersByValue = async(page:number) => {
        if(!player_search){ return }
        const plys = await SocialComponentApi.searchPlayersByValue(player_search, page);
        setPlayerTag({
            ...player_tag,
            loading: false,
            players: plys,
            offset: page
        })
    }

    const renderPlayers = (data:{ item:PublicPlayerProps, index:number }) => {
        return (
            <Button key={data.item.player_id.toString()} float style={{ flexDirection:'row', alignItems:'center', margin:2, padding:3, width:tag_width, borderRadius:100 }} onPress={() => handleSelectPlayer(data.item)}>
                <Image
                    source={{ uri: data.item.profile_pic }}
                    style={{ height:30, width:30, borderRadius:100 }}
                    resizeMode='cover'
                />
                <View transparent style={{flex:1, marginLeft:5 }}>
                    <Text style={{ maxWidth:tag_width - 35 }} theme='description' size={10} textAlign='center'>@{data.item.username}</Text>
                </View>
            </Button>
        )
    }
    
    if(!visible){ return <></> }

    return (
        <View transparent>
            {type == 'player' ?
            <View float style={{ flex:1 }}>
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                    <View transparent style={{ flex:1 }}>
                        <Text theme='h2'>Tag A Player!</Text>
                    </View>
                    <Button
                        title='X'
                        type='close'
                        style={{ padding:0, borderRadius:100, height:25, width:25, justifyContent:'center', alignItems:'center' }}
                        float
                        onPress={() => onCancel()}
                    />
                </View>
                <View>
                    <SearchBox
                        button_style={{ padding:10 }}
                        placeholder='Search Players ...'
                        onSearch={() => searchPlayersByValue(0)}
                        onFocusPosition={onFocusPosition}
                        onChange={(text) => setPlayerSearch(text)}
                    />
                </View>
                <View transparent style={{ padding:5 }}>
                    <FlatList
                        key={'player_tags'}
                        numColumns={2}
                        data={visible_players}
                        keyExtractor={(item) => item.player_id.toString()}
                        renderItem={renderPlayers}
                    />
                </View>
                <Pagination
                    offset={player_tag.offset}
                    onNext={() => player_search ? searchPlayersByValue(player_tag.offset + 1) : searchPlayers(working_tag, player_tag.offset + 1)}
                    onPrevious={() => player_search ? searchPlayersByValue(player_tag.offset - 1) : searchPlayers(working_tag, player_tag.offset - 1)}
                />
            </View>
            :<></>}
        </View>
    )
}

export default TagSelector